// extracted by mini-css-extract-plugin
export default {"root":"DualRoleModeSwitch_root__OlxYR"};